import { createReducer } from "@reduxjs/toolkit";
import { resetUserPassword } from "./reset-user-password";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const resetUserPasswordReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(resetUserPassword.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(resetUserPassword.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(resetUserPassword.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
});
